// extracted by mini-css-extract-plugin
export default {"-large":"progress-bar-module__-large--lYVcT","progressBar":"progress-bar-module__progressBar--zTFEy","progressContainer":"progress-bar-module__progressContainer--dP0Qa"};